import React from "react";

const Paragraph = ({ text }) => {
  return (
    <>
      {text.split("\\n").map((line, index) => {
        return (
          <p key={index} className="text-content">
            {line}
          </p>
        );
      })}
    </>
  );
};

export default Paragraph;
